import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';

import { INTERNAL_COMPANY_HIDDEN_PAGES } from 'app/auth/authUtils';
import PropTypes from 'prop-types';

import { getIsFromInternalCompany, getMasterPermissionsToPage } from 'store/auth/selectors';

export const WithPagePermissionsPropTypes = {
  isManageAllowed: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  isViewAllowed: PropTypes.bool.isRequired,
};

const withPagePermissions = (pageCode, redirect) => WrappedComponent => props => {
  const permissions = useSelector(getMasterPermissionsToPage(pageCode));
  const isFromInternalCompany = useSelector(getIsFromInternalCompany);

  const isForbiddenPageView = !permissions.isViewAllowed;

  const isInternalCompanyHiddenPage =
    isFromInternalCompany && INTERNAL_COMPANY_HIDDEN_PAGES.includes(pageCode);

  if (redirect && (isForbiddenPageView || isInternalCompanyHiddenPage)) {
    redirect(props);

    return null;
  }

  if (isInternalCompanyHiddenPage) {
    return <Redirect to="/pages/errors/error-404" />;
  }

  if (isForbiddenPageView) {
    return null;
  }

  return <WrappedComponent {...permissions} {...props} />;
};

export default withPagePermissions;
